import type { ActorSubclass, ActorConfig, Agent } from '@icp-sdk/core/agent';
import type { _SERVICE } from '@backend/kudos_backend.did';

import { Actor } from '@icp-sdk/core/agent';
import { safeGetCanisterEnv } from '@icp-sdk/core/agent/canister-env';

import { idlFactory } from '../../../declarations/kudos_backend/kudos_backend.did.js';

// Wrapper local para o backend, gerado com `@icp-sdk/bindgen --actor-disabled`
// (só idlFactory/_SERVICE puros). Mantemos a instanciação manual do actor em
// vez da classe wrapper gerada, para não precisar revisar os call sites que
// hoje montam/consomem shapes de Candid cru em src/icpadapters/.

export const canisterId = safeGetCanisterEnv<{
  readonly ['PUBLIC_CANISTER_ID:kudos_backend']: string;
}>()?.['PUBLIC_CANISTER_ID:kudos_backend'] as string;

export type CreateActorOptions = {
  agent: Agent;
  actorOptions?: ActorConfig;
};

export function createActor(
  targetCanisterId: string,
  options: CreateActorOptions
): ActorSubclass<_SERVICE> {
  return Actor.createActor<_SERVICE>(idlFactory, {
    agent: options.agent,
    canisterId: targetCanisterId,
    ...options.actorOptions,
  });
}
